import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';

import Card from './Card';
import InfluencerForm from './InfluencerForm';
import SignUpForm from './SignUpForm';

const ThreeCards = ({
  isDialog = false,
  openForm,
  setOpenForm,
  contentOne,
  contentTwo,
  contentThree,
  hasThirdCard,
}) => {
  const containerRef = useRef();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('xs'));
  const showButton = openForm.influencer || openForm.advertiser || openForm.agency;
  const lastCardStyle = mobile ? { marginTop: 50, paddingBottom: showButton ? 0 : 80 } : null;
  const titleStyle = mobile ? { fontSize: 16 } : null;

  const containerStyle = {
    minHeight: 'auto',
    maxWidth: hasThirdCard ? 800 : 600,
    margin: '0 auto',
    padding: '0 15px',
  };

  const scrollIntoView = () => {
    setTimeout(() => {
      containerRef.current.scrollIntoView({ behavior: 'smooth' });
    }, 0);
  };

  return (
    <div style={!isDialog ? { paddingTop: 50 } : {}}>
      <h2 style={{ textAlign: 'center', margin: '35px 0 30px', fontSize: 24 }}>Which are you?</h2>

      <Grid container justifyContent="center" style={containerStyle}>
        <Grid item xs={6} sm={hasThirdCard ? 4 : 6}>
          <Card
            title="Individual"
            content={contentOne}
            firstChild
            buttonText="Select"
            handleClick={() => {
              setOpenForm({ influencer: true, advertiser: false, agency: false });
              scrollIntoView();
            }}
            selected={openForm.influencer}
            showButton={showButton}
            containerStyle={{ height: 185, minWidth: 165 }}
            titleStyle={titleStyle}
          />
        </Grid>

        <Grid item xs={6} sm={hasThirdCard ? 4 : 6}>
          <Card
            title="Agency / Company"
            content={contentTwo}
            buttonText="Select"
            handleClick={() => {
              setOpenForm({ agency: true, influencer: false, advertiser: false });
              scrollIntoView();
            }}
            selected={openForm.agency}
            showButton={showButton}
            containerStyle={{ height: 185, minWidth: 165 }}
            titleStyle={titleStyle}
          />
        </Grid>

        {hasThirdCard && (
          <Grid item xs={6} sm={4} style={lastCardStyle}>
            <Card
              title="Company"
              content={contentThree}
              buttonText="Select"
              handleClick={() => {
                setOpenForm({ advertiser: true, influencer: false, agency: false });
                scrollIntoView();
              }}
              selected={openForm.advertiser}
              showButton={showButton}
              containerStyle={{ height: 185 }}
              titleStyle={titleStyle}
            />
          </Grid>
        )}
      </Grid>

      <div ref={containerRef}>
        {openForm.influencer && <InfluencerForm isDialog={isDialog} primaryInterest="buy" />}
        {openForm.advertiser && <SignUpForm isDialog={isDialog} />}
        {openForm.agency && <SignUpForm isDialog={isDialog} agency />}
      </div>
    </div>
  );
};

ThreeCards.propTypes = {
  openForm: PropTypes.object.isRequired,
  setOpenForm: PropTypes.func.isRequired,
  contentOne: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  contentTwo: PropTypes.string,
  contentThree: PropTypes.string,
  isDialog: PropTypes.bool,
  hasThirdCard: PropTypes.bool,
};

ThreeCards.defaultProps = {
  contentOne: '',
  contentTwo: '',
  contentThree: '',
  isDialog: false,
  hasThirdCard: true,
};

export default ThreeCards;
